import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetOrderEmailNotificationCatalogQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOrderEmailNotificationCatalogQuery = { __typename?: 'Query', orderEmailNotificationCatalog: Array<{ __typename?: 'OrderEmailNotificationCatalogEntryData', docType: Types.OrderEmailDocType, hasDeliveryImplementation: boolean, enabled: boolean, channel: Types.OrderEmailChannel, configured: boolean, recipients: Array<string>, defaultRecipientRoles: Array<Types.OrderEmailRecipientRole>, includeSalesPersonCc: boolean, includeServicingSiteManagerCc: boolean, emailSubject?: string | null, emailBody?: string | null, senderId?: string | null }> };


export const GetOrderEmailNotificationCatalogDocument = new TypedDocumentString(`
    query GetOrderEmailNotificationCatalog {
  orderEmailNotificationCatalog {
    docType
    hasDeliveryImplementation
    enabled
    channel
    configured
    recipients
    defaultRecipientRoles
    includeSalesPersonCc
    includeServicingSiteManagerCc
    emailSubject
    emailBody
    senderId
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetOrderEmailNotificationCatalog: build.query<GetOrderEmailNotificationCatalogQuery, GetOrderEmailNotificationCatalogQueryVariables | void>({
      query: (variables) => ({ document: GetOrderEmailNotificationCatalogDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetOrderEmailNotificationCatalogQuery, useLazyGetOrderEmailNotificationCatalogQuery } = injectedRtkApi;
